import { Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import { useState, useCallback, useEffect, useRef } from 'react';
import { ImageTypes } from '../../enums';
import { formatTagsMultipart } from '../../utils/utils';

import FileInput from '../common/file-input';
import BasicSpinner from '../common/basic-spinner';
import { Toaster, createToast } from '../common/toasts';

//================================================================

export default function ImageAdd({onCancel, onChange, id, disabled}) {

  const [imageName, setImageName] = useState("");
  const [imageType, setImageType] = useState(ImageTypes.UNSET);
  const [file, setFile] = useState(null);
  const [reset, setReset] = useState(false);
  const [toasts, setToasts] = useState([]);

  //----------------------------------------------------------------

  useEffect(() => {
    const data = {
      'id': id,
      'name': imageName,
      'file': file,
      'image_type': imageType
    }
    onChange(data);
    console.log('data updated: ', data);
  }, [imageName, file, imageType]);


  const clearSelection = useCallback(() =>{
    setReset(true);
    setImageName("");
    setFile(null);
  });

  const handleFileSelection = useCallback(async (event) => {

    event.preventDefault();
    event.stopPropagation();

    const selection = event.target.files[0];

    if(!selection) return;

    if (selection.type === "image/png" || selection.type === "image/jpeg"){
      setReset(false);
      setImageName(selection.name);
      setFile(selection);
    } else {
      setToasts([...toasts, createToast(
        "File type not accepted:",
        "Please select a .png or .jpg"
      )]);
    }
  });



  //----------------------------------------------------------------

  return (
    <div className="mb-3">
      <Row className="align-items-center mb-1">

        <FileInput
          onChange={handleFileSelection}
          fileName={file ? file.name : null}
        />

        <Col className="col-1 text-center">
          <Button
            size="sm"
            className="border-0 rounded p-0 align-items-center"
            variant="outline-secondary"
            onClick={() => onCancel(id)}
            disabled={disabled}
          >
            <i className="bi bi-x-lg"></i>
          </Button>
        </Col>
      </Row>

      <Row className="align-items-center g-2">
        <InputGroup className="col">
          <InputGroup.Text>Image Type</InputGroup.Text>
          <Form.Select
            onChange={(event) => setImageType(event.target.value)}
            disabled={disabled}
            defaultValue={imageType}
          >
            {Object.keys(ImageTypes).map(key =>
              <option
                key={`itemType-option-${key}`}
                value={ImageTypes[key]}
              >
                {ImageTypes[key]}
              </option>
            )}
          </Form.Select>
        </InputGroup>
      </Row>

      <Toaster toasts={toasts} />

    </div>
  );
}
